import { render, staticRenderFns } from "./GFSettlementRejectedList.vue?vue&type=template&id=f320a27e"
import script from "./GFSettlementRejectedList.vue?vue&type=script&lang=js"
export * from "./GFSettlementRejectedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports